var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreWebBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24941 19.4977C4.64841 19.4977 3.22441 18.4727 2.70741 16.9467L2.67241 16.8317C2.55041 16.4277 2.49941 16.0877 2.49941 15.7477V8.92969L0.0734114 17.0277C-0.238589 18.2187 0.472411 19.4537 1.66541 19.7827L17.1284 23.9237C17.3214 23.9737 17.5144 23.9977 17.7044 23.9977C18.7004 23.9977 19.6104 23.3367 19.8654 22.3627L20.7664 19.4977H6.24941Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C10.103 9 11 8.103 11 7C11 5.897 10.103 5 9 5C7.897 5 7 5.897 7 7C7 8.103 7.897 9 9 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 2H6.5C5.122 2 4 3.122 4 4.5V15.5C4 16.878 5.122 18 6.5 18H21.5C22.878 18 24 16.878 24 15.5V4.5C24 3.122 22.878 2 21.5 2ZM6.5 4H21.5C21.776 4 22 4.224 22 4.5V11.599L18.841 7.913C18.506 7.52 18.021 7.31 17.5 7.298C16.982 7.301 16.496 7.531 16.164 7.929L12.45 12.387L11.24 11.18C10.556 10.496 9.443 10.496 8.76 11.18L6 13.939V4.5C6 4.224 6.224 4 6.5 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreWebBanner);
export default __webpack_public_path__ + "static/media/store-web-banner.cc45e9cd7490abbe8a252bbcccb2aa3d.svg";
export { ForwardRef as ReactComponent };